import { LOGOUT_USER, ENV_CHANGE } from "../types/authTypes";
import {
  CREATE_POT_ROUND,
  PUBLISH_POT_ROUND,
  FETCH_POT_ROUNDS,
  CREATE_POT_FIXTURE,
  FETCH_POT_FIXTURES,
  CREATE_POT,
  FETCH_POTS,
  FETCH_POT_ENTRIES,
  FETCH_POT_PAYMENTS,
  CREATE_POT_ROLLOVER_CREDIT,
  FETCH_POT_ROLLOVER_CREDITS,
  FETCH_SUPPORTED_LEAGUE_FIXTURES
} from "../types/potTypes";

const INITIAL_STATE = {
  rounds: {
    data: [],
    pagination: {}
  },
  fixtures: {
    data: {},
    pagination: {}
  },
  pots: {
    data: {},
    pagination: {}
  },
  entries: {
    data: {},
    pagination: {}
  },
  payments: {
    data: {},
    pagination: {}
  },
  rolloverCredits: {
    data: [],
    pagination: {}
  },
  supportedLeagueFixtures: {
    data: [],
    pagination: {}
  }
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_POT_ROUND:
      return {
        ...state,
        rounds: {
          ...state.rounds,
          data: [action.payload, ...state.rounds.data]
        }
      };
    
    case PUBLISH_POT_ROUND:
      return {
        ...state,
        rounds: {
          ...state.rounds,
          data: state.rounds.data.map(round => 
            round.id === action.payload.id ? action.payload : round
          )
        }
      };
    
    case FETCH_POT_ROUNDS:
      return {
        ...state,
        rounds: {
          data: action.payload.data,
          pagination: action.payload.pagination
        }
      };
    
    case CREATE_POT_FIXTURE:
      const { fixture, meta } = action.payload;
      return {
        ...state,
        fixtures: {
          ...state.fixtures,
          data: {
            ...state.fixtures.data,
            [meta.round_id]: [
              ...(state.fixtures.data[meta.round_id] || []),
              fixture
            ]
          }
        },
        rounds: {
          ...state.rounds,
          data: state.rounds.data.map(round => 
            round.id === meta.round_id ? 
              { ...round, end_time: meta.new_end_time || round.end_time } : 
              round
          )
        }
      };
    
    case FETCH_POT_FIXTURES:
      return {
        ...state,
        fixtures: {
          ...state.fixtures,
          data: {
            ...state.fixtures.data,
            [action.payload.round_id]: action.payload.data
          },
          pagination: {
            ...state.fixtures.pagination,
            [action.payload.round_id]: action.payload.pagination
          }
        }
      };
    
    case CREATE_POT:
      return {
        ...state,
        pots: {
          ...state.pots,
          data: {
            ...state.pots.data,
            [action.payload.round_id]: [
              ...(state.pots.data[action.payload.round_id] || []),
              action.payload
            ]
          }
        }
      };
    
    case FETCH_POTS:
      return {
        ...state,
        pots: {
          ...state.pots,
          data: {
            ...state.pots.data,
            [action.payload.round_id]: action.payload.data
          },
          pagination: {
            ...state.pots.pagination,
            [action.payload.round_id]: action.payload.pagination
          }
        }
      };
    
    case FETCH_POT_ENTRIES:
      return {
        ...state,
        entries: {
          ...state.entries,
          data: {
            ...state.entries.data,
            [action.payload.pot_id]: action.payload.data
          },
          pagination: {
            ...state.entries.pagination,
            [action.payload.pot_id]: action.payload.pagination
          }
        }
      };
    
    case FETCH_POT_PAYMENTS:
      return {
        ...state,
        payments: {
          ...state.payments,
          data: {
            ...state.payments.data,
            [action.payload.user_id]: action.payload.data
          },
          pagination: {
            ...state.payments.pagination,
            [action.payload.user_id]: action.payload.pagination
          }
        }
      };
    
    case CREATE_POT_ROLLOVER_CREDIT:
      return {
        ...state,
        rolloverCredits: {
          ...state.rolloverCredits,
          data: [action.payload, ...state.rolloverCredits.data]
        }
      };
    
    case FETCH_POT_ROLLOVER_CREDITS:
      return {
        ...state,
        rolloverCredits: {
          data: action.payload.data,
          pagination: action.payload.pagination
        }
      };
    
    case FETCH_SUPPORTED_LEAGUE_FIXTURES:
      return {
        ...state,
        supportedLeagueFixtures: {
          data: action.payload.data,
          pagination: action.payload.pagination
        }
      };
    
    case ENV_CHANGE:
    case LOGOUT_USER:
      return INITIAL_STATE;
    
    default:
      return state;
  }
};
